import React, { useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import toast from 'react-hot-toast'
import { formValidator } from '../../helpers'
import { signUp, signIn, confirmEmail, forgottenPassword, verifyOTP, resetPassword, resendVerificationMail } from '../../store/actions'
import Ellipse4 from '../../assets/Ellipse4.svg'
import DecoContainer from '../../Layout/DecoContainer'
import Container from './styles'
import SignInForm from './SignInForm'
import SignUpForm from './SignUpForm'; 
import ConfirmEmailForm from './ConfirmEmailForm';
import ResetPasswordForm from './ResetPasswordForm';
import ForgottenPasswordForm from './ForgottenPasswordForm';
import VerifyOTPForm from './VerifyOTPForm';

const Auth = () => {
  const { authMethod } = useParams()
  const dispatch = useDispatch()
  const storedState = sessionStorage.getItem('authState')
  const [loading, setLoading] = useState(false)
  const [confirm_password_error, setConfirm_password_error] = useState(false)
  const [password_error, setPassword_error] = useState(false)
  const navigate = useNavigate()

  const [formData, setFormState] = useState(() =>
    storedState ? JSON.parse(storedState) : {
      email: '',
      password: '',
      otp: '',
      confirm_password: '',
      token: ''
    },
  )

  const resentMail = ()=>{
    setLoading(true)
    dispatch(resendVerificationMail())
    setLoading(false)
  }

  const handleInput = ({ target }) => {
    setFormState((s) => ({
      ...s,
      [target.name]: target.value,
    }))
  }

  const handleSubmit = async () => {
    if (
      formValidator(document.forms['auth--form'].getElementsByTagName('input'), setConfirm_password_error, setPassword_error )
    ) {
      try {
        setLoading(true)
        
        let response;
        let message = '';
        
        if (authMethod === 'sign-in') {
          response = await dispatch(signIn(formData, navigate))
          message = response?.message || 'Login successful'
        } else if (authMethod === 'forgotten-password') {
          response = await dispatch(forgottenPassword(formData))
          message = response?.message || 'OTP sent to your email'
        } else if (authMethod === 'verify-otp') {
          response = await dispatch(verifyOTP(formData))
          message = response?.message || 'OTP verified successfully'
        } else if (authMethod === 'reset-password') {
          response = await dispatch(resetPassword(formData))
          message = response?.message || 'Password changed successfully'
        } else if (authMethod === 'confirm-email') {
          response = await dispatch(confirmEmail(formData))
          message = response?.message || 'Email confirmed'
        } else if (authMethod === 'sign-up') {
          response = await dispatch(signUp(formData, navigate))
          message = response?.message || 'Account created'
        }

        // Navigation logic based on auth method
        if (authMethod === 'confirm-email') {
          navigate('/auth/sign-in')
        } else if (authMethod === 'forgotten-password') {
          navigate('/auth/verify-otp')
        } else if (authMethod === 'verify-otp') {
          navigate('/auth/reset-password')
        } else if (authMethod === 'reset-password') {
          navigate('/auth/sign-in')
        } else if (authMethod === 'sign-in') {
          // signIn action handles navigation
        }
        
        setLoading(false)
      } catch (error) {
        setLoading(false)
      }
    }
  }

  return (
    <DecoContainer
      header={
        <header>
          <div className="ellipse--container">
            <img src={Ellipse4} alt="Ellipse" />
            <h2>
              {authMethod === 'sign-in'
                ? 'Welcome'
                : authMethod === 'sign-up'
                ? 'Create An Account'
                : 'Welcome'}
            </h2>
          </div>
          <p>
            {authMethod === 'sign-in'
              ? 'Login to continue'
              : authMethod === 'sign-up'
              ? 'Fill the form below to register your account'
              : authMethod === 'confirm-email'
              ? 'Confirm Your Email'
              : authMethod === 'forgotten-password'
              ? "Enter your email to receive OTP"
              : authMethod === 'verify-otp'
              ? "Enter the OTP sent to your email"
              : "Enter your new password"
              }
          </p>
        </header>
      }
      content={
        <Container>
          <form
            name="auth--form"
            onSubmit={(e) => {
              e.preventDefault()
              handleSubmit()
            }}
            noValidate
          >
            {authMethod === 'sign-in' && <SignInForm {...{ formData, handleInput, loading, password_error, setPassword_error }} />}
            {authMethod === 'sign-up' && <SignUpForm {...{ formData, handleInput, loading, password_error, confirm_password_error, setConfirm_password_error, setPassword_error }} />}
            {authMethod === 'confirm-email' && <ConfirmEmailForm {...{ formData, handleInput, loading, resentMail}} />}
            {authMethod === 'forgotten-password' && <ForgottenPasswordForm {...{ formData, handleInput, loading}} />}
            {authMethod === 'verify-otp' && <VerifyOTPForm {...{ formData, handleInput, loading}} />}
            {authMethod === 'reset-password' && <ResetPasswordForm {...{ formData, handleInput, loading, password_error, setPassword_error}} />}
          </form>
        </Container>
      }
    />
  )
}

export default Auth
